import {
  renderRequiredRule,
  renderValidator,
  renderLengthFieldRule,
  checkValidityInn,
} from "@/utils/renderRulesForm";

import {
  checkStorage
} from "@/utils/baseFunctions";

export default (sender) => ({
  cityFrom: [renderRequiredRule("Пожалуйста выберите город")],
  officeFrom: [renderRequiredRule(""), renderValidator({
    validatorFunc: ()=>!checkStorage('from'),
  })],
  senderType: [],
  innSender: [
    renderRequiredRule("Пожалуйста введите ИНН"),
    renderValidator({
      validatorFunc: checkValidityInn,
      message: "Некорректно введён ИНН",
    }),
    {
      validator: (rule, value, callback) => {
        if (!value) return callback();
        if (sender.senderType === 1 && value.length !== 10) {
          callback(new Error("Для юр. лица ИНН должен состоять из 10 символов"));
        } else if (sender.senderType === 2 && value.length !== 12) {
          callback(new Error("Для ИП ИНН должен состоять из 12 символов"));
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
  kppSender: [
    renderRequiredRule("Пожалуйста введите КПП"),
    renderLengthFieldRule({
      min: 9,
      max: 9,
      message: "КПП должен состоять из 9 символов",
    }),
  ],
  name: [renderRequiredRule("Пожалуйста введите название организации")],
  surnameSender: [
    renderRequiredRule("Введите фамилию"),
    renderValidator({
      validatorFunc: (value) => value.length > 0,
      message: "Введите фамилию",
    }),
    renderValidator({
        validatorFunc: (value) =>
        (value.length >= 2),
        message: "Слишком коротко",
    }),
  ],
  firstNameSender: [
    renderRequiredRule("Введите имя"),
    renderValidator({
      validatorFunc: (value) => value.length > 0,
      message: "Введите имя",
    }),
    renderValidator({
        validatorFunc: (value) =>
        (value.length >= 2),
        message: "Слишком коротко",
    }),
  ],
  secondNameSender: [
    renderRequiredRule("Введите отчество"),
    renderValidator({
      validatorFunc: (value) => value.length > 0,
      message: "Введите отчество",
    }),
    renderValidator({
        validatorFunc: (value) =>
        (value.length >= 2),
        message: "Слишком коротко",
    }),
  ],
  phoneSender: [
    renderRequiredRule("Пожалуйста введите телефон"),
    renderValidator({
      validatorFunc: (value) =>
        !!value.match(/^\+{0,1}\d \([3,4,6-9]\d{2}\) \d{3}-\d{2}-\d{2}$/),
      message: "Некорректно введён номер",
    }),
  ],
  emailSender: [
    {
      validator: (rule, value, callback) => {
        if (
          (sender.senderType && (value === "")) ||
          (!(value === "") && !value.match(/^([a-zA-Z0-9_-]+\.)*[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*\.[a-zA-Z]{2,6}$/))
        ) {
          callback(new Error("Пожалуйста введите почту"));
        }
        // else if (!value.match(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
        //   callback(new Error("Почта введена неверно"));
        // }
        callback();
      },
      trigger: "blur",
    },
    // renderValidator({
    //   validatorFunc: (value) =>
    //     !!value.match(
    //       /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    //     ) ,
    //   message: "Пожалуйста введите почту",
    // }),
    ],
});
